import { render, staticRenderFns } from "./sign.vue?vue&type=template&id=a5d4eae0&scoped=true"
import script from "./sign.vue?vue&type=script&lang=js"
export * from "./sign.vue?vue&type=script&lang=js"
import style0 from "./sign.vue?vue&type=style&index=0&id=a5d4eae0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d4eae0",
  null
  
)

export default component.exports